import { STAR1Locales } from '../internationalization/localeHelper';

/**
 * Determines if the provided locale is a STAR2 locale by checking if it's not in the STAR1 locales list.
 *
 * **Important:** This function is intended for server-side checks only.
 * For client-side checks, use the `useStar2` hook instead.
 *
 * @param {Object} params - The parameters object
 * @param {string} [params.locale] - The locale string to check (e.g., 'en-us', 'fr-fr')
 *
 * @returns {boolean} Returns `true` if the locale is a STAR2 locale (not in STAR1Locales),
 *                    `false` if the locale is a STAR1 locale or if no locale is provided
 *
 * @example
 * ```typescript
 * // Check if a locale is STAR2
 * const isStar2 = isStar2Check({ locale: 'en-gb' });
 *
 * // No locale provided
 * const isStar2 = isStar2Check({ locale: undefined }); // returns false
 * ```
 */

export const isStar2Check = ({ locale }: { locale?: string }): boolean => {
  if (!locale) return false;

  return !STAR1Locales.includes(locale);
};
